import gql from 'graphql-tag';
import { FavoriteProductFragment } from '@app/favorite/fragments';
import XpressAskFragment from '@drc/pages/Product/shared/components/XpressShipping/fragments/XpressAskFragment';

export interface Product {
  name: string;
  productCategory: string;
  title: string;
  urlKey: string;
  uuid: string;
  favorite?: boolean;
  followed?: boolean;
  media: {
    smallImageUrl: string;
  };
  market: {
    bidAskData: {
      lowestAsk: number;
    };
    salesInformation: {
      lastSale: number;
    };
  };
  id?: string;
  sizeDescriptor?: string;
  variants?: [];
}

export const parseDynamicProductList = (result, limit) => {
  const edges = result?.edges ?? [];
  const listOfProducts = edges.slice(0, limit);
  return listOfProducts.map((edge) => ({
    ...edge?.node,
    releaseDate: edge?.node?.traits?.[0]?.value,
    market: {
      ...edge?.node?.market,
      ...edge?.node?.market?.salesInformation,
      ...edge?.node?.market?.bidAskData,
      ...edge?.node?.market?.state?.numberOfCustodialAsks,
      deadstockSold: edge?.node?.market?.deadStock?.sold,
    },
  }));
};

export const PRODUCT_COLLECTION = gql`
  query FetchProductCollection(
    $id: String
    $country: String!
    $currencyCode: CurrencyCode!
    $limit: Int!
    $marketName: String
    $skipFavorite: Boolean!
    $page: Int!
  ) {
    productCollection(id: $id) {
      tileType
      priceType
      footnotesType
      trackingEvent
      helpMessage
      products(page: $page, limit: $limit) {
        ... on ProductsConnection {
          edges {
            node {
              id
              title
              browseVerticals
              gender
              productCategory
              name
              urlKey
              uuid
              ...FavoriteProductFragment @skip(if: $skipFavorite)
              variants {
                id
              }
              media {
                smallImageUrl
              }
              ...XpressAskFragment
              market(currencyCode: $currencyCode) {
                bidAskData(country: $country, market: $marketName) {
                  highestBid
                  lastHighestBidTime
                  lastLowestAskTime
                  lowestAsk
                }
                statistics {
                  lastSale {
                    amount
                  }
                  last72Hours {
                    salesCount
                  }
                  annual {
                    salesCount
                  }
                  last90Days {
                    averagePrice
                  }
                }
              }
              traits(filterTypes: [RELEASE_DATE]) {
                name
                value
              }
            }
          }
          pageInfo {
            total
          }
        }
      }
      seeAllCTA {
        title
        url
        urlType
      }
      title
    }
  }
  ${XpressAskFragment}
  ${FavoriteProductFragment}
`;
